import * as Moment from 'moment';

export const CurrentDate = () => {
    return Moment().format('YYYY-MM-DD');
}

export const SomeDaysAgo = (days: number) => {
    return Moment().subtract(days, "days").format('YYYY-MM-DD');
}


// WEBPACK FOOTER //
// ./src/services/DateService.tsx